(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-content.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-content.js');

'use strict';

const Loader = svs.components.ReactLoader.Loader;
const {
  UPCOMING,
  FINISHED,
  REG_OPEN_DRAW_DEFINED,
  REG_CLOSED_DRAW_DEFINED,
  REG_OPEN_DRAW_OPEN,
  REG_CLOSED_DRAW_OPEN,
  REG_OPEN_DRAW_LIVE,
  REG_CLOSED_DRAW_LIVE,
  REG_OPEN_DRAW_FINALIZED,
  REG_CLOSED_DRAW_FINALIZED,
  NO_COMPETITION
} = svs.components.marketplaceCompetition.competitionHandler.common.constants.competitionStates;
const {
  CompetitionClosedDrawDefined,
  CompetitionClosedDrawFinalized,
  CompetitionClosedDrawLive,
  CompetitionClosedDrawOpen,
  CompetitionFinished,
  CompetitionOpenDrawDefined,
  CompetitionOpenDrawFinalized,
  CompetitionOpenDrawLive,
  CompetitionOpenDrawOpen,
  CompetitionUpcoming,
  NoCompetition
} = svs.components.marketplaceCompetition.overviewHero.content;
const useContent = competitionState => {
  switch (competitionState) {
    case UPCOMING:
      return CompetitionUpcoming;
    case REG_OPEN_DRAW_DEFINED:
      return CompetitionOpenDrawDefined;
    case REG_OPEN_DRAW_OPEN:
      return CompetitionOpenDrawOpen;
    case REG_OPEN_DRAW_LIVE:
      return CompetitionOpenDrawLive;
    case REG_OPEN_DRAW_FINALIZED:
      return CompetitionOpenDrawFinalized;
    case REG_CLOSED_DRAW_DEFINED:
      return CompetitionClosedDrawDefined;
    case REG_CLOSED_DRAW_OPEN:
      return CompetitionClosedDrawOpen;
    case REG_CLOSED_DRAW_LIVE:
      return CompetitionClosedDrawLive;
    case REG_CLOSED_DRAW_FINALIZED:
      return CompetitionClosedDrawFinalized;
    case FINISHED:
      return CompetitionFinished;
    case NO_COMPETITION:
      return NoCompetition;
    default:
      return Loader;
  }
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.hooks.useContent', useContent);

 })(window);